import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()// 让每个请求携带自定义token 请根据实际情况自行修改
  }
  config.headers['which_app'] = "wx257f5f7cbb65ce46"
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
   // 网络请求status为2000时，都会在此回调
    const res = response.data
    if(response.config.url.indexOf('/order/downloadprescription') != -1){
      return response;
    }
    if(res.code == 1420) {
      Promise.reject('error')
      return Message({
        message: "患者姓名与身份证号不符!",
        type: 'warning',
        duration: 3 * 1000
      });
    }
    if (res.code !== 200) {
      if (res.code == 1015) {
        Message({
          message: "该账号已被锁定,请1小时后重新登录",
          type: 'error',
          duration: 3 * 1000
        })
      } else if (res.code == 1018) {
        Message({
          message: "请输入正确的密码:至少8～16位，由数字字母符号（非纯数字、非纯字母）组成",
          type: 'error',
          duration: 3 * 1000
        })
      } else if (res.code == 3015) {
        Message({
          message: "正在操作发货，请勿重复点击",
          type: 'error',
          duration: 3 * 1000
        })
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }

      // 401:未登录;
      if (res.code === 401||res.code === 403) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
     
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js